
	import Component from 'vue-class-component'
	import StylePopup from './components/stylePopup/stylePopup';
	import moduleStore from './store/videoEditor';
	import Vue from 'vue';
	import PageState from './store/state';
	import player from './components/player/player';
	import TabBar from './components/tabBar/tabBar';
	import SpeakerPopup from './components/speakerPopup/speakerPopup';
	import PronunciationPopup from './components/pronunciationPopup/pronunciationPopup';
  import ChooseBgm from '../chooseBgm/chooseBgm';
	import SearchSpeaker from '../searchSpeaker/searchSpeaker';
	import BgVolume from './components/bgVolume/bgVolume.vue'
	import { TabTypeMap } from './utils/constant';
  import { judgeDeviceType } from '@/utils/device'
	import { Provide } from 'vue-property-decorator';
	import * as Diff from 'diff';
import { handleDiffList, debouncedSaveArticle } from './utils/utils';
import { toast } from '@/utils/util';
import { _getSwitch, _getUserInfo, isJZYCD, isNull } from '@/utils/utils';
import { getQueryString } from '@/utils/location';

	interface ImgItem {
		imgUrl: string
		startTime: number
		endTime: number
		animateType?: string
	  }
	/**components**/
	@Component({
		components: {
			player,
			StylePopup,
			TabBar,
      ChooseBgm,
			SpeakerPopup,
			SearchSpeaker,
			BgVolume,
			PronunciationPopup
		}
	})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class videoEditorPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		visible = false; // 字体、样式弹窗是否显示
		speakerVisible = false; // 发音人弹窗是否显示
    bgVisible = false;// 背景音 是否显示
    bgmVisible = false;// 背景音乐选择 是否显示 
		canvaDom:any=null
		imgList: ImgItem[] = [];
		isShowBottom = true;
		animationType=  ["PullInUp", "PullInDown", "PullInLeft", "PullInRight", "ZoomIn", "ZommInX", "ZoomInY", "SlideInUp", "SlideInDown", "SlideInLeft", "SlideInRight", "PressInUp", "PressInDown", "PressInLeft", "PressInRight", "PressInX", "PressInY", "UncoverFromTop", "UncoverFromBottom", "ShutterX", "ShutterY", "ZoomFullScreen", "Wheel", "Tooth", "FadeIn", "FadeOut", "StackInTop", "StackInBottom", "StackInLeft", "StackInRight", "TopLaser", "BottomLaser", "RightLaser", "LeftLaser"]
		playerRef: any = null       
		bgmRef: any = null
		stylePopupRef: any = null
		speakerPopupRef: any = null
		speakerInfo: any = {}
    isApp =judgeDeviceType.isAPP;
		scaleRatio = ''
		isShowVolume = false;
		// 要改变的多音字列表
		changeWordList = [];
		// 要改变的数字读音列表
		changeNumberList = [];
		multitoneWordList = []
		// 当前最新字幕
		currentSubtitlesText = ''
		oldSubtitlesText = ''
		orginialNumberTextList = []
		// 字幕变化
		diffList = []
		isChangeText = false
    	// bgMusicRef : any = null 
		// service?: service;
		// controller?: controller;
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
			// 获取文字模板列表
			this.getTextTemplateList()
		}
		async mounted(moduleData:IinjectDatas){
			/*this.$http("getDataList",{}).then((response:any)=>{
				console.log(response)
			}).catch((ex:any)=>{
				console.log(ex)
			})*/
      (window as any).hideBgmPop = this.hideBgmPop;
			this.state.title="这是更改后的title"
			this.state.self = this;
			this.$nextTick(() => {
				this.playerRef = this.$refs.playerRef
				this.stylePopupRef = this.$refs.stylePopupRef
				this.speakerPopupRef = this.$refs.speakerPopupRef
        this.bgmRef = this.$refs.bgmRef
			})
			this.$bus.$on(this.$EventBusKey.CANVASPLAY, this.canvasPlay)
			this.$bus.$on(this.$EventBusKey.REQUEST_SAVE_ARTICLE, this.requestSaveArticle)
			this.$bus.$on(this.$EventBusKey.SAVE_DATA, this.saveData)
			this.$bus.$on(this.$EventBusKey.CHANGE_POLYPHONE, this.changePolyphone)
			this.$bus.$on(this.$EventBusKey.CHANGE_NUMBER, this.changeNumber)

			this.$bus.$on(this.$EventBusKey.EDIT_TEXT_TEMPLATE, this.handleEditTextTemplate)
			this.$bus.$on(this.$EventBusKey.SHOW_STYLE_POPUP, this.handleShowStylePopup)

			this.$bus.$on(this.$EventBusKey.UPDATE_ARTICLE_AI, this.udateAi)
			this.$bus.$on(this.$EventBusKey.TRACK_SCROLL, this.handleTrackScroll)
			try {
				let querSource = ''
				const resource = decodeURIComponent(getQueryString('resource'))
				const userInfo:any = await _getUserInfo(this)
				const isNetSwitch:any = await _getSwitch(this)
				const originSource = userInfo?.originSource
				if (!isNull(resource) && isJZYCD(resource)) {
					querSource = resource
				} else if (!isNull(originSource) && isJZYCD(originSource)) {
					querSource = originSource
				}
				if (querSource && !isNetSwitch) {
					this.state.isSwitch = false
				}
			} catch (error) {
				
			}
		}
	
		beforeDestroy() {
		  this.playerRef.reCreateAudio('save-article')
			this.playerRef.saveVideoPromot()
			this.removeBus()
		}
		removeBus() {
			this.$bus.$off(this.$EventBusKey.CANVASPLAY, this.canvasPlay)
			this.$bus.$off(this.$EventBusKey.REQUEST_SAVE_ARTICLE, this.requestSaveArticle)
			this.$bus.$off(this.$EventBusKey.SAVE_DATA, this.saveData)
			this.$bus.$off(this.$EventBusKey.CHANGE_POLYPHONE, this.changePolyphone)
			this.$bus.$off(this.$EventBusKey.CHANGE_NUMBER, this.changeNumber)
			this.$bus.$off(this.$EventBusKey.TRACK_SCROLL, this.handleTrackScroll)
		}
		
		@Provide('triggerEditorSubtitle')
		addListenEditorSubtitle(val, type) {
			this.visible = true;
			this.stylePopupRef.setParams(type || TabTypeMap.EDITFONT, {
				...val,
				source: 'cover'
			})
			// console.log('addListenEditorSubtitle', val)
		}
		// 保存数据
		saveData() {
			this.playerRef.saveProject()
		}
		/**
		 * 多音字读法改变
		 */
		changePolyphone(polyList) {
			console.log('changePolyphone', polyList)
			this.multitoneWordList = polyList
			this.changeWordList = polyList.filter(item => item.curpinyin && item.curpinyin)
		}
		/**
		 * 数字读法改变
		 */
		changeNumber(info) {
			this.changeNumberList = info.filterList
			this.orginialNumberTextList = info.orginialTextList

		}
		// 视频播放
		canvasPlay() {
			this.visible = false
			this.speakerVisible = false
			this.bgVisible = false
		}
		/**
		 * 请求保存文章
		 */
		requestSaveArticle() {
			this.playerRef.saveVideoPromot()
		}
		udateAi() {
			this.playerRef.updateAricleAiStatus()
		}
		handleTrackScroll() {
			(this.$refs.tabBarRef as any).backTabBar();
		}
		
		/**
		 * 点击字幕
		 * @param params
		 */
		editorSubtitleClick(params) {
			this.visible = true;
			this.stylePopupRef.setParams(TabTypeMap.EDITFONT, params)
		}
		setScaleRatio(ratio) {
			this.scaleRatio = ratio
		}
		/**
		 * 编辑字幕
		 */
		editorSubtitle(text) {
			this.currentSubtitlesText = text
			this.playerRef.updateSubtitles(text)
		}
		changeBottomStatus(status) {
			this.isShowBottom = status
		}
		/**
		 * 切换tab数据
		 * @param type
		 * @param params 
		 */
		changeTabList(params) {
			if (params.type === TabTypeMap.SPEAKER) {
				this.speakerInfo = params.param
			}
			(this.$refs.tabBarRef as any).changeTabList(params);
		}
		/**
		 * 回到主tab
		 */
		toHomeTab() {
			(this.$refs.tabBarRef as any).backTabBar()
		}
		getPlayerSpeaker(info){
			this.speakerInfo=info
		}
		changeTab(tabType, params) {
			console.log('changeTab--tabType', tabType)
			console.log('changeTab--params', params)
			switch(tabType) {
				// 编辑封面
				case TabTypeMap.COVER:
					this.playerRef.showCoverPopup()
					break;
				// 编辑文字
				case TabTypeMap.EDITFONT:
				case TabTypeMap.FONT:
				case TabTypeMap.WORDPRON:
				case TabTypeMap.NUMPRON:
					this.visible = true
					if (params.source !== 'text_template') {
						this.playerRef.updatePosition()
					}
					this.stylePopupRef.setParams(tabType, params)
					break;
				// 编辑图片
				case TabTypeMap.EDITIMG:
					// this.playerRef.playerContainerHeight = 574 / 100
					this.playerRef.showGeneratePickture(params)
					break;
				// 设置封面
				case TabTypeMap.SETCOVER:
					if (params.imgUrl) {
						toast('设置封面成功')
						this.playerRef.completeCover(params.imgUrl)
					}
					break;
				// 样式
				case TabTypeMap.STYLE:
					this.visible = true
					if (params.source === 'text_template') {
						params.text = this.state.operatingTextContent.text
					}
					this.stylePopupRef.setParams(TabTypeMap.STYLE, params)
					break;
				// 编辑文本
				case TabTypeMap.TEXT:
					this.$bus.$emit('add-text-track')
					break;
				// 字幕
				case TabTypeMap.SUBTITLES:
					if(this.playerRef.isShortPlay) {
						if(!this.playerRef.uuidSelectedText) {
							this.$toast('请选择字幕片段');
						} else {
							this.playerRef.subtitlesEditCallback(this.playerRef.uuidSelectedText);
						}
						return;
					}
					const curSelect = this.playerRef.curSelect
          console.log('curSelect', curSelect)
					if (curSelect && curSelect.type === 'text') {
						this.visible = true
						this.playerRef.isEdit = true
						this.playerRef.updateSelectText()
						this.stylePopupRef.setParams(TabTypeMap.EDITFONT, this.playerRef.renderEle)
					} else {
						this.$toast({
							message: '请选择字幕片段'
						})
					}
					break;
				// 发音人
				case TabTypeMap.SPEAKER:
					this.playerRef.trackSpeakerClick()
					break;
				// 配背景音
				case TabTypeMap.MUSIC:
					if(this.isApp){
						let unableBack = (<any>window).unableBack;
						unableBack.postMessage('BGM');
					}
					console.log("music----")
          this.playerRef.onTouchStart()
					this.toChooseBgmList();
					break;
				// 调节声音
				case TabTypeMap.VOLUME:
					this.isShowVolume = true
					break;
				// 编辑配音
				case TabTypeMap.EDITSPEAKER:
					console.log('changeTab', params)
					this.speakerVisible = true
					break;
				// 删除背景音
				case TabTypeMap.DELETEVOLUME:
					this.playerRef.deleteBgm()
					break;
				// 删除当前字幕
				case TabTypeMap.DELFONT:
					break;
				// 删除图片
				case TabTypeMap.DELIMG:
					break;
				// 编辑文本轨道
				case TabTypeMap.ADD_TEXT_CONTENT:
				case TabTypeMap.EDIT_TEXT_CONTENT:
				case TabTypeMap.EDIT_TEXT_CONTENT_STYLE:
				case TabTypeMap.EDIT_TEXT_TEMPLATE:
					this.visible = true
					if (this.state.operatingTextIndex !== null) {
						this.$bus.$emit(this.$EventBusKey.EDIT_TEXT_TEMPLATE, this.state.operatingTextIndex)
					} else {
						// 新添加一个文本
						this.state.operatingTextContent = {
							// 模板 id
							id: null,
							// 文字模板的文本
							text: '',
							// 文本颜色
							color: '#ffffff',
							// 文本透明度
							opacity: 0.92,
							// 描边颜色
							strokeColor: '',
							// 文本字体
							fontFamily: 'HarmonyOS_Sans_SC_Medium',
							// 文本背景色
							backgroundColor: '',
							// 文本字体大小
							fontSize: 14,
							// 素材宽度
							width: 0,
							// 素材高度
							height: 0,
							// 缩放比例
							scale: 1,
							// x 轴距离 %
							x: 0.04,
							// Y 轴距离 %
							y: 0.15
						}
						this.state.operatingTextList.push(this.state.operatingTextContent)
						this.state.operatingTextIndex = this.state.operatingTextList.length - 1
						params.text = ''
						this.stylePopupRef.setParams(tabType, params)
					}
					// 设置编辑状态
					this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, true)
					// 初始化参数
					// this.stylePopupRef.setParams(tabType, params)
					break;
				// 删除文本轨道
				case TabTypeMap.DELETE_TEXT_CONTENT:
					this.state.savedTextContent = {
						// 模板 id
						id: null,
						// 文字模板的文本
						text: '',
						// 素材宽度
						width: 0,
						// 素材高度
						height: 0,
						// 缩放比例
						scale: 1,
						// x 轴距离 %
						x: 0.04,
						// Y 轴距离 %
						y: 0.15
					}
					this.state.operatingTextContent = {
						// 模板 id
						id: null,
						// 文字模板的文本
						text: '',
						// 文字模版颜色
						color: '#ffffff',
						// 文字透明度
						opacity: 0.92,
						// 描边透明度
						strokeColor: '',
						// 文本字体
						fontFamily: 'HarmonyOS_Sans_SC_Medium',
						// 文本背景色
						backgroundColor: '',
						// 文本字号大小
						fontSize: 14,
						// 素材宽度
						width: 0,
						// 素材高度
						height: 0,
						// 缩放比例
						scale: 1,
						// x 轴距离 %
						x: 0.04,
						// Y 轴距离 %
						y: 0.15
					}
					this.state.operatingTextList = this.state.operatingTextList.filter((item, index) => {
						return index !== this.state.operatingTextIndex
					})
					this.state.savedTextList = [...this.state.operatingTextList]
					this.state.operatingTextIndex = null
					// 移除编辑状态
					this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, false)
					// 关闭 tabbar
					this.toHomeTab()
					// 保存文章
					debouncedSaveArticle(this)
					break;
			}
			
		}
		/**
		 * 关闭弹窗
		 */
		closeStylePopup() {
			this.visible = false
			this.playerRef.hideEdit()
			this.diffList = []
			this.isChangeText = false
			this.changeWordList = []
			this.multitoneWordList = []
			this.changeNumberList = []
			this.orginialNumberTextList = []
			this.oldSubtitlesText = ''
			this.stylePopupRef.oldSubtitlesText = ''
			this.currentSubtitlesText = ''
		}
		/**
		 * 弹窗确认
		 */
		confirmStylePopup(source) {
			if (source === 'cover' || source === 'brain_title') {
				this.closeStylePopup()
				return
			} else if (source === 'text_template') {
				// 取消编辑状态
				this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, false)
				// 关闭弹窗
				this.closeStylePopup()
				let isUpload = false
				if (!this.state.operatingTextContent.text) {
					this.state.operatingTextList = this.state.operatingTextList.filter((item, index) => {
						return index !== this.state.operatingTextIndex && item.text
					})
					this.state.savedTextList = this.state.operatingTextList
					isUpload = false
				} else {
					// 有文本内容
					this.state.savedTextList = [
						...this.state.operatingTextList
					]
					
					let materialList = []
					materialList.push({
						type: 'video',
						url: this.state.operatingTextTemplateInfo.url,
						wRatio: 1,
						hRatio: 1,
						xRatio: 0,
						yRatio: 0,
						start_time: this.state.operatingTextTemplateInfo.start_time,
						end_time: this.state.operatingTextTemplateInfo.end_time
					})
					const newTextTemplate = {
						materialList,
						textTemplateList: this.state.savedTextList
					}
					if (JSON.stringify(newTextTemplate) !== JSON.stringify(this.state.oldTextTemplateInfo)) {
						isUpload = true
					}
				}
				// 保存文章
				debouncedSaveArticle(this, isUpload)
				return
			}
			const oldSubtitlesText = this.stylePopupRef.oldSubtitlesText
			this.oldSubtitlesText = oldSubtitlesText
			console.log('oldSubtitlesText', oldSubtitlesText)
			if (!this.currentSubtitlesText) {
				this.currentSubtitlesText = this.stylePopupRef.subtitlesText
			}
			const diffList = Diff.diffChars(oldSubtitlesText, this.currentSubtitlesText)
			this.diffList = handleDiffList(diffList, this.currentSubtitlesText)
			console.log('diffList', this.diffList)
			const filterList = this.diffList.filter(item => item.added === true || item.removed === true || item.replaced === true)
			this.isChangeText = filterList.length > 0;
			
			if (this.isChangeText) {
				(this.$refs.pronunciationPopupRef as any).show = true
			} else if (this.changeWordList.length || this.changeNumberList.length) {
				this.playerRef.getCurTTsWordVOList({
					diffList: this.diffList,
					pinyinWordList: this.multitoneWordList,
					numberWordList: this.changeNumberList,
					orginialNumberTextList: this.orginialNumberTextList,
					checkedInfo: {
						isEditChecked: false,
      			isWordChecked: true,
      			isNumChecked: true
					},
					currentText: this.currentSubtitlesText
				})
				this.closeStylePopup()
			} else {
				this.closeStylePopup()
			}
		}
		/**
		 * 确认修改
		 */
		confirmEdit(info) {
			this.playerRef.getCurTTsWordVOList({
				diffList: this.diffList,
				pinyinWordList: this.multitoneWordList,
				numberWordList: this.changeNumberList,
				orginialNumberTextList: this.orginialNumberTextList,
				checkedInfo: info,
				currentText: this.currentSubtitlesText
			})
			this.closeStylePopup()
		}
		cancelEdit() {
			const curText = this.stylePopupRef.subtitlesText
			const oldText = this.stylePopupRef.oldSubtitlesText
			if (curText !== oldText) {
				this.editorSubtitle(oldText)
				this.requestSaveArticle()
			}
			
			this.closeStylePopup()
		}
		changeSpeaker(speakerInfo) {
			this.speakerInfo = speakerInfo;
			this.playerRef.updateSpeakerAudio(speakerInfo)
		}
    changeBgm(bgmInfo){
      console.log('---app确认了背景音',bgmInfo)
      this.playerRef.updateBackAudio(bgmInfo)
    }
		syncSpeaker(speakerInfo){
			this.speakerInfo = speakerInfo
		}
		updateBgVolume(value) {
			(this.$refs.bgVolumeRef as any).volume = Math.floor(value * 100)
		}
		/**
		 * 改变声音
		 * @param value
		 */
		onChangeVolume(value) {
			this.playerRef.changeBgVolume(value)
		}
		onConfirmVolume() {
			this.isShowVolume = false
		}
    toChooseBgmList(){
			console.log("music----toChooseBgmList", this.isApp)
      if(this.isApp){
				this.bgmVisible = true
      }else{//小程序
        const ww_token = localStorage.getItem('ww_token')
        this.$navigateTo({
          url: "/baohuo-package/pages/choose-bgm/choose-bgm?ww_token="+ww_token,
        })
      }
    }
    hideBgmPop(){
      this.bgmVisible = false;
    }
		doClickVideoEditor() {
			this.$bus.$emit('doClickVideoEditor');
		}
		
		/****************************** 文字模板 ******************************/

		handleEditTextTemplate(index) {
			this.visible = true
			// 设置当前选择的文字模板 index
			this.state.operatingTextIndex = index
			const operatingTextContent = this.state.operatingTextList.find((item, index) => {
				return index === this.state.operatingTextIndex
			})
			// 深拷贝赋值
			this.state.savedTextContent = {
				...operatingTextContent
			}
			this.state.operatingTextContent = {
				...operatingTextContent
			}
			// 打开弹窗
			this.stylePopupRef.setParams(TabTypeMap.EDIT_TEXT_TEMPLATE, {
				...(operatingTextContent || {}),
				source: 'text_template'
			})
		}
		handleShowStylePopup(type) {
			this.visible = true
			this.stylePopupRef.setParams(TabTypeMap.BRAIN_TITLE, {
				source: 'brain_title'
			})
		}

		/** 获取提供的文字模板列表 */
		getTextTemplateList() {
			this.$http('getTextTemplateListApi')
				.then(res => {
					const { code, data } = res
					if (code === 200) {
						this.state.defaultTextTemplateList = data
					}
				})
		}

	}